// extracted by css-extract-rspack-plugin
export default {"cls1":"BibliographyList-cls1_4sJ","cls2":"BibliographyList-cls2_Fwi BibliographyList-cls1_4sJ"};